var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    {
      staticClass: "entity-header-v2",
      attrs: { align: "center", "no-gutters": "" },
    },
    [
      _vm._t("icon", function () {
        return [_vm.icon ? _c("icon", { attrs: { type: _vm.icon } }) : _vm._e()]
      }),
      _vm._v(" "),
      _c(
        "v-col",
        {
          staticClass:
            "entity-header-v2__content d-flex flex-column flex-md-row align-start align-md-center",
        },
        [
          _c(
            "h1",
            {
              staticClass:
                "entity-header-v2__name headline primary--text text-truncate",
              class: { "ml-2": _vm.hasIcon },
              attrs: { "data-testid": "entity-name" },
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _vm.details
            ? _c(
                "span",
                {
                  staticClass:
                    "entity-header-v2__details ml-2 mt-1 mt-md-0 flex-shrink-0 text-truncate",
                  attrs: { "data-testid": "entity-details" },
                },
                [_vm._v(_vm._s(_vm.details))]
              )
            : _vm._e(),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }